export default __webpack_public_path__ + "static/media/48-icon-list.7e71ef35.svg";